<template>
  <div class="dynamic-tables">
    <div v-if="showLoading" class="text-center">
      <img
        :src="require('@/assets/loadingfish.gif')"
        alt="Loading..."
        width="150px"
      />
      <p id="cancel-label">Sedang memuat data...</p>
    </div>
    <div v-if="!showLoading">
      <h2 class="page-title">Pemutakhiran</h2>
      <Widget customHeader>
        <div>
          <div class="d-flex justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-primary mr-1"
                @click="$router.push('/app/pemutakhiran/form')"
              >
                <i class="fa fa-plus"></i> Tambah
              </button>
              <!-- <button type="button" class="btn btn-success">
              <i class="fa fa-file-text-o"></i> Excel
            </button> -->
            </div>
            <div class="d-flex">
              <div class="d-flex">
                <div class="d-flex align-items-center mr-2">
                  <label for="search" class="mr-2 mb-0">Search: </label>
                  <input
                    v-model="search.value"
                    type="text"
                    class="form-control"
                    id="search"
                  />
                </div>
                <div>
                  <select v-model="search.field" class="form-control">
                    <option value="instansi_pemohon">Instansi Pemohon</option>
                    <option value="nomor_izin_terbit">Nomor Izin Terbit</option>
                    <option value="jenis_permohonan">Jenis Permohonan</option>
                    <option value="createdAt">Tgl. Pengajuan</option>
                    <option value="jenis_pemuktahiran">
                      Jenis Pemutakhiran
                    </option>
                  </select>
                </div>
              </div>
              <div class="d-flex ml-4">
                <div class="d-flex align-items-center mr-2">
                  <label for="search" class="mb-0">Sort By: </label>
                </div>
                <div>
                  <select v-model="sort.field" class="form-control">
                    <option value="createdAt">Tgl. Pengajuan</option>
                  </select>
                </div>
                <div class="ml-2">
                  <select v-model="sort.direction" class="form-control">
                    <option value="DESC">DESC</option>
                    <option value="ASC">ASC</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <table id="tablePemutakhiran" class="table" style="width: 100%">
            <thead>
              <tr>
                <th>No</th>
                <th>Instansi Pemohon</th>
                <th>Nomor Izin Terbit</th>
                <th>Jenis Permohonan</th>
                <th>Tgl. Pengajuan</th>
                <th>Jenis Pemutakhiran</th>
                <th>Status</th>
                <th>File</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in dataPermohonan" :key="index">
                <!-- No -->
                <td>{{ index + pagination.firstInPage }}</td>
                <!-- Instansi Pemohon -->
                <td>{{ data.instansi_pemohon }}</td>
                <!-- Nomor Izin Terbit -->
                <td>{{ data.nomor_izin_terbit }}</td>
                <!-- Jenis Permohonan -->
                <td>{{ data.jenis_permohonan }}</td>
                <!-- Tgl. Pengajuan -->
                <td>{{ formatDate(data.createdAt, 'DD MMMM YYYY') }}</td>
                <!-- Jenis -->
                <td>{{ data.jenis_pemuktahiran }}</td>
                <!-- Status -->
                <td>{{ data.status }}</td>
                <!-- File -->
                <td>
                  <div style="width: 250px" class="row">
                    <div class="col-8">
                      <select
                        style="width: 150px; margin-right: 10px"
                        class="form-select"
                        v-model="data.selected_file"
                      >
                        <option disabled selected value="#">
                          - Pilih File -
                        </option>
                        <option
                          v-for="file in listUnduhFile(data)"
                          :value="file.value"
                          :disabled="!file.value"
                        >
                          {{ file.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-4 d-flex align-items-center">
                      <span v-if="data.selected_file !== '#'">
                        <a :href="data.selected_file" target="_blank"
                          ><i class="fa fa-download" style="font-size: 20px"
                        /></a>
                      </span>
                    </div>
                  </div>
                </td>
                <!-- Aksi -->
                <td>
                  <div style="max-width: 200px">
                    <b-button-toolbar>
                      <b-button
                        v-if="data.status !== 'Ditolak'"
                        size="sm"
                        variant="info"
                        class="text-white m-1"
                        @click="
                          $router.push(
                            `/app/pemutakhiran/form?id_pemutakhiran=${data.id}`,
                          )
                        "
                      >
                        <i class="fa fa-eye"></i> Detail
                      </b-button>
                      <b-button
                        v-if="data.status === 'Ditolak'"
                        size="sm"
                        variant="success"
                        class="text-white m-1"
                        @click="
                          $router.push(
                            `/app/pemutakhiran/form?id_pemutakhiran=${data.id}`,
                          )
                        "
                      >
                        <i class="fa fa-edit"></i> Perbaiki
                      </b-button>
                      <b-button
                        v-if="data.status === 'Ditolak'"
                        size="sm"
                        variant="warning"
                        class="text-white m-1"
                        @click="showCatatan(data)"
                      >
                        <i class="fa fa-file-o"></i> Lihat Catatan
                      </b-button>
                    </b-button-toolbar>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- prettier-ignore -->
          <div class="d-flex justify-content-between mt-4">
          <div>
            <template v-if="pagination.total">
              Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ? pagination.limit*pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
            </template>
          </div>
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'first'})">
                  <span aria-hidden="true">Awal</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'prev'})">
                  <span aria-hidden="true">Sebelumnya</span>
                </a>
              </li>
              <li 
                v-for="i in pagination.pageNumber" 
                class="page-item"
              >
                <a :class="['page-link', {'active': i === `${pagination.currentPage}`}]" href="#" @click="changePage({page: i})">{{ i }}</a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'next'})">
                  <span aria-hidden="true">Selanjutnya</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'last'})">
                  <span aria-hidden="true">Akhir</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        </div>
      </Widget>

      <b-modal
        id="modal-catatan"
        title="Catatan Penolakan Pemutakhiran"
        size="md"
      >
        <template>
          <b-form>
            <div class="row g-0">
              <div class="col-12">
                <label> Catatan Penolakan </label>
                <div
                  class="bg-white p-2 d-block w-100"
                  style="border: 1px #999999 solid; border-radius: 5px"
                >
                  <div
                    v-html="formCatatan.catatan_penolakan_pemuktahiran"
                  ></div>
                </div>
              </div>
            </div>
          </b-form>
        </template>
        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              size="sm"
              class="float-right"
              @click="$bvModal.hide('modal-catatan')"
            >
              Tutup
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Widget from '@/components/Widget/Widget'
import vSelect from 'vue-select'
import { formatDate } from '../../../helper/helpernew'
import InputFile from '../Components/InputFile.vue'
import Swal from 'sweetalert2'
import axios from 'axios'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import DOMPurify from 'dompurify'

export default {
  components: { Widget, vSelect, InputFile },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      wygEditor: ClassicEditor,
      dataPermohonan: [],
      formCatatan: {
        catatan_penolakan_pemuktahiran: null,
      },

      selectedData: null,
      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: 'instansi_pemohon',
        value: '',
      },
      sort: {
        field: 'createdAt',
        direction: 'DESC',
      },
      debounceTerm: null,
      showLoading: false,
    }
  },
  methods: {
    async getdata() {
      $('#tablePemutakhiran').DataTable().destroy()
      return this.loaddata()
    },

    async loaddata() {
      this.showLoading = true
      this.dataPermohonan = []

      // prettier-ignore
      const api = `api/pemuktahiran/dataTable`+
        `?page=${this.pagination.currentPage}`+
        `&filter=id_pembuat,=,${this.user.id}${this.search.value!==''?`;${this.search.field},${this.search.field==='tanggal_penerbitan'||this.search.field==='masa_berlaku'?'>=':'like'},${this.search.value}`:''}`+
        `&sort=${this.sort.field},${this.sort.direction}`
      return axios
        .get(this.baseapi + api, this.getApiOption())
        .then((response) => {
          const res = response.data
          this.pagination.limit = res.limit
          this.pagination.total = res.total
          this.pagination.firstInPage =
            (this.pagination.currentPage - 1) * res.limit + 1
          this.pagination.lastPage = Math.ceil(res.total / res.limit)
          this.setPagination()
          this.dataPermohonan = response.data.data.map((d) => ({
            ...d,
            selected_file: '#',
          }))
          this.initDatatable()
          this.showLoading = false
        })
    },

    deleteData(id) {
      Swal.fire({
        title: 'Apakah Anda yakin?',
        text: 'Anda tidak akan dapat mengembalikan data ini!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Batal',
      }).then(async (val) => {
        if (val.isConfirmed) {
          axios
            .delete(
              this.baseapi + 'api/pemuktahiran/' + id,
              this.getApiOption(),
            )
            .then((response) => {
              Swal.fire('Berhasil', 'Berhasil menghapus record', 'success')
              this.loaddata()
            })
            .catch((error) => {
              Swal.fire('Gagal', 'Gagal menghapus record', 'error')
            })
        }
      })
    },

    showCatatan(record) {
      this.formCatatan.catatan_penolakan_pemuktahiran = DOMPurify.sanitize(
        record.catatan_penolakan_pemuktahiran,
      )
      this.$bvModal.show('modal-catatan')
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch((err) => {})

      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (
          this.pagination.currentPage >=
          this.pagination.lastPage - 2
        ) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment('DD MMMM YYYY')
        var t = $('#tablePemutakhiran').DataTable({
          paging: false,
          info: false,
          filter: false,
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                return type == 'export' ? meta.row + 1 : data
              },
            },
          ],
          buttons: [],
        })
      }, 300)
    },

    listUnduhFile(record) {
      return [
        {
          label: 'Surat Permohonan',
          value: record.file_permohonan_pemuktahiran,
        },
        {
          label: 'Surat Undangan',
          value: record.filename_final_undangan,
        },
        {
          label: 'Final Putusan',
          value: record.file_final_putusan,
        },
      ]
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },

    formatDate,
  },
  mounted() {
    this.getdata()
  },
}
</script>
